module.exports = __webpack_public_path__ + "static/media/hero-mobile.f930c547.svg";